import { Container } from '@mui/material';
import { LogAnalyzer } from '../sections/LogAnalyzer';
import Metatags from '../components/MetaTags/MetaTags';

export default function LogAnalyzerPage({ permissions }) {
  return (
    <>
      <Metatags metaTagName="Object Analyser | ISV Insights" />
      <Container maxWidth="xl">
        <LogAnalyzer permissions={permissions} />
      </Container>
    </>
  );
}
